// extracted by mini-css-extract-plugin
module.exports = {"headerName":"solo-event-leaderboard_headerName__ghc_y","headerIcon":"solo-event-leaderboard_headerIcon__B6wIr"};